//报表信息
const DiscountRecord = () => import( /*webpackChunkName:'operation'*/ '@/page/operation/parkingRecord/discountRecord.vue')
const InterimCarPayRecord = () => import( /*webpackChunkName:'operation'*/ '@/page/operation/parkingRecord/interimCarPayRecord.vue')
const FastenCarPayRecord = () => import( /*webpackChunkName:'operation'*/ '@/page/operation/parkingRecord/fastenCarPayRecord.vue')
const ShopRechargeRecord = () => import( /*webpackChunkName:'operation'*/ '@/page/operation/parkingRecord/shopRechargeRecord.vue')
const UserList = () => import( /*webpackChunkName:'operation'*/ '@/page/operation/parkingRecord/userList.vue')
const RecoveryRoadArrearsRecord = () => import( /*webpackChunkName:'operation'*/ '@/page/operation/parkingRecord/recoveryRoadArrearsRecord.vue')

const RouteTemp = () => import(/*webpackChunkName:'operation'*/'@/page/commons/routeTemp.vue')

export const parkingRecord = {
    path: '/main/record',
    name: '车场报表信息',
    component: RouteTemp,
    meta: {
        requireAuth: true,

    },
    children: [{
            path: '/main/record/interimCarPayRecord',
            name: '临停缴费',
            meta: {
                requireAuth: true,
            },
            component: InterimCarPayRecord
        }, {
            path: '/main/record/discountRecord',
            name: '优免记录',
            meta: {
                requireAuth: true,
            },
            component: DiscountRecord
        },
        {
            path: '/main/record/fastenCarPayRecord',
            name: '月卡续费',
            meta: {
                requireAuth: true,
            },
            component: FastenCarPayRecord
        },
        {
            path: '/main/record/shopRechargeRecord',
            name: '商家充值',
            meta: {
                requireAuth: true,
            },
            component: ShopRechargeRecord
        },
        {
            path: '/main/record/userlist',
            name: '车主信息',
            meta: {
                requireAuth: true,
            },
            component: UserList
        },
        {
            path: '/main/record/recoveryRoadArrearsRecord',
            name: '追缴道路欠费',
            meta: {
                requireAuth: true,
            },
            component: RecoveryRoadArrearsRecord
        }
    ]
}